<template>
  <div>
    <button
      v-if="creditCard.status === 'Unverified'"
      class="btn btn-primary btn-sm m-r-10"
      :disabled="disabled"
      @click="verifyCard"
    >
      {{ $t('VERIFY') }}
    </button>
    <button
      v-if="!creditCard.default"
      v-tooltip.right="$t('ACCOUNT_BILLING_CC_REMOVE_TT')"
      class="btn btn-list-function"
      :disabled="disabled"
      @click="deleteCard"
    >
      <i class="typcn typcn-trash" />
    </button>
  </div>
</template>

<script>
import messages from '../../locales';
import sharedMessages from '@/core/locales';
import { mapState } from 'vuex';

export default {
  name: 'CreditCardsActions',
  components: {
  },
  props: {
    creditCard: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState({
      accountId: 'currentAccountId',
    }),
  },
  methods: {
    verifyCard() {
      this.$emit('verify-card');
    },
    deleteCard() {
      this.$emit('delete-card');
    }
  },

  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>